export class ViewSwitcher {
	switcherSelector = '.js-view-switcher';
	buttonSelector = '.js-view-switcher__button';
	activeButtonClass = 'theme-switcher__button--active';
	gridViewClass = 'view-switcher-feed--grid';
	listViewClass = 'view-switcher-feed--list';

	constructor(switcher, container) {
		if (!switcher || !container) return;

		this.switcher = switcher;
		this.container = container;

		this.init();
	}

	init() {
		this.switcher.addEventListener('click', this.handleSwitcherClick);
	}

	reflectContainerView(view) {
		this.container.classList.toggle(this.gridViewClass, view === 'grid');
		this.container.classList.toggle(this.listViewClass, view === 'list');
	}

	handleSwitcherClick = ({ target }) => {
		const button = target.closest(this.buttonSelector);
		if (!button || button.classList.contains(this.activeButtonClass)) return;

		const { view } = button.dataset;

		this.switcher.querySelectorAll(this.buttonSelector).forEach((btn) => {
			btn.classList.toggle(this.activeButtonClass, btn === button);
		});

		this.reflectContainerView(view);

		this.switcher.dispatchEvent(new CustomEvent('viewSwitcher', { detail: { view } }));
	};
}
